import { render, staticRenderFns } from "./srvFrameDialog.vue?vue&type=template&id=70d26aa4&scoped=true&"
import script from "./srvFrameDialog.vue?vue&type=script&lang=js&"
export * from "./srvFrameDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70d26aa4",
  null
  
)

export default component.exports